import wbsBookingsApi from '../apis/wbsBookingsApi';

const deleteVenturesService = async (ventureId: string): Promise<void> => {
  await wbsBookingsApi.delete(`/ventures/${ventureId}`);
};

export default deleteVenturesService;
